// extracted by mini-css-extract-plugin
export var productImage = "_v8-0";